module.exports = __webpack_public_path__ + "img/ione9.e7222dd2.png";